import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';

const ModalNuevoSoporte = ({
    showModalNuevoSoporte,
    setShowModalNuevoSoporte,
    cargandoComboBoxSoporte,
    handleSubmit,
    onSubmitNuevoSoporte,
    register,
    errors,
    nivelSoporte,
    herramientas,
    statusSolucion,
    reset
}) => {
    return (
        <Modal
            show={showModalNuevoSoporte}
            onHide={() => setShowModalNuevoSoporte(false)}
            size="lg"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            {cargandoComboBoxSoporte ? (
                <h3>
                    <Spinner className="text-inline" animation="border" variant="primary" /> Cargando...
                </h3>
            ) : (
                <Form noValidate onSubmit={handleSubmit(onSubmitNuevoSoporte)}>
                    <Modal.Header>
                        <Modal.Title>Registrar Ticket de Soporte T&eacute;cnico</Modal.Title>
                        <FalconCloseButton
                            className="btn btn-circle btn-sm transition-base p-0"
                            onClick={() => setShowModalNuevoSoporte(false)}
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col xs={2} md={2}>
                                <img src="/img/soporte48.png" alt="Soporte" />
                            </Col>
                            <Col xs={10} md={10}>
                                <p>
                                    Debes registrar los detalles del Soporte T&eacute;cnico que brindaste al cliente.
                                    Indica la fecha, hora y tiempo requerido.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6} md={6}>
                                <Form.Control
                                    type="hidden"
                                    isInvalid={!!errors.idClienteAkasia}
                                    {...register("idClienteAkasia")}
                                />
                                <Form.Label>Fecha del Soporte</Form.Label>
                                <Form.Group className="mb-3">
                                    <Form.Control
                                        type="date"
                                        {...register("dFechaSoporte", {
                                            required: true
                                        })}
                                        isInvalid={!!errors.dFechaSoporte}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.dFechaSoporte && errors.dFechaSoporte.message}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6} md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nivel de Soporte</Form.Label>
                                    <Form.Select
                                        aria-label="Default select"
                                        isInvalid={!!errors.idCatNivelSoporte}
                                        {...register("idCatNivelSoporte", {
                                            required: true
                                        })}
                                    >
                                        <option value="">Selecciona un nivel</option>
                                        {nivelSoporte.map((nivel, index) => {
                                            return (
                                                <option
                                                    key={index}
                                                    value={nivel.idCatNivelSoporte}
                                                >
                                                    {nivel.iNivel} - {nivel.vNombreNivel}
                                                </option>
                                            )
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>T&iacute;tulo</Form.Label>
                                    <Form.Control
                                        type="text"
                                        autoComplete="off"
                                        onKeyUp={(event) => {
                                            event.target.value = event.target.value.toUpperCase()
                                        }}
                                        isInvalid={!!errors.vTitulo}
                                        {...register("vTitulo", {
                                            required: 'Es necesario el titulo',
                                            maxLength: 100,
                                            minLength: 1
                                        })}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vTitulo && errors.vTitulo.message}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descripci&oacute;n (m&iacute;nimo 50 caracteres)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        autoComplete="off"
                                        onKeyUp={(event) => {
                                            event.target.value = event.target.value.toUpperCase()
                                        }}
                                        isInvalid={!!errors.vDescripcion}
                                        {...register("vDescripcion", {
                                            required: 'La descripción es requerida',
                                            maxLength: 200,
                                            minLength: 50
                                        })}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vDescripcion && errors.vDescripcion.message}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={4} md={4}>
                                <Form.Label>Duraci&oacute;n (minutos)</Form.Label>
                                <Form.Group className="mb-3">
                                    <Form.Select
                                        aria-label="Default select"
                                        isInvalid={!!errors.iMinutos}
                                        {...register("iMinutos", {
                                            required: true
                                        })}
                                    >
                                        <option value="">Selecciona...</option>
                                        <option value="10">10 minutos</option>
                                        <option value="20">20 minutos</option>
                                        <option value="30">30 minutos</option>
                                        <option value="45">45 minutos</option>
                                        <option value="60">1 hora</option>
                                        <option value="90">1 hora y media</option>
                                        <option value="120">2 horas</option>
                                        <option value="150">2 horas y media</option>
                                        <option value="180">3 horas</option>
                                        <option value="240">4 horas</option>
                                        <option value="300">5 horas</option>
                                        <option value="360">6 horas</option>
                                        <option value="420">7 horas</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.iMinutos && errors.iMinutos.message}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={4} md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Herramienta Utilizada</Form.Label>
                                    <Form.Select
                                        aria-label="Default select"
                                        isInvalid={!!errors.idCatHerramienta}
                                        {...register("idCatHerramienta", {
                                            required: true
                                        })}
                                    >
                                        <option value="">Selecciona...</option>
                                        {herramientas.map((herr, index) => {
                                            return (
                                                <option
                                                    key={index}
                                                    value={herr.idCatHerramienta}
                                                >
                                                    {herr.idCatHerramienta} - {herr.vNombreHerramienta}
                                                </option>
                                            )
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col xs={4} md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo de contacto</Form.Label>
                                    <Form.Select
                                        aria-label="Default select"
                                        isInvalid={!!errors.vTipoContacto}
                                        {...register("vTipoContacto", {
                                            required: true
                                        })}
                                    >
                                        <option value="">Selecciona...</option>
                                        <option value="WhatsApp">WhatsApp</option>
                                        <option value="Llamada por teléfono">Llamada por tel&eacute;fono</option>
                                        <option value="Messenger">Messenger</option>
                                        <option value="Comentario">Comentario</option>
                                        <option value="En persona">En persona</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Estatus de la soluci&oacute;n</Form.Label>
                                    <Form.Select
                                        aria-label="Default select"
                                        isInvalid={!!errors.idCatStatusSolucion}
                                        {...register("idCatStatusSolucion", {
                                            required: true
                                        })}
                                    >
                                        <option value="">Selecciona...</option>
                                        {statusSolucion.map((st, index) => {
                                            return (
                                                <option
                                                    key={index}
                                                    value={st.idCatStatusSolucion}
                                                >
                                                    {st.idCatStatusSolucion} - {st.vDescripcionStatus}
                                                </option>
                                            )
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => { setShowModalNuevoSoporte(false); reset() }} variant='primary'>
                            Cerrar
                        </Button>
                        <Button type="submit" variant='success'>
                            Registrar
                        </Button>
                    </Modal.Footer>
                </Form>
            )}
        </Modal>
    );
};

ModalNuevoSoporte.propTypes = {
    showModalNuevoSoporte: PropTypes.bool.isRequired,
    setShowModalNuevoSoporte: PropTypes.func.isRequired,
    cargandoComboBoxSoporte: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmitNuevoSoporte: PropTypes.func.isRequired,
    register: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    nivelSoporte: PropTypes.arrayOf(
        PropTypes.shape({
            idCatNivelSoporte: PropTypes.number,
            iNivel: PropTypes.number,
            vNombreNivel: PropTypes.string
        })
    ).isRequired,
    herramientas: PropTypes.arrayOf(
        PropTypes.shape({
            idCatHerramienta: PropTypes.number,
            vNombreHerramienta: PropTypes.string
        })
    ).isRequired,
    statusSolucion: PropTypes.arrayOf(
        PropTypes.shape({
            idCatStatusSolucion: PropTypes.number,
            vDescripcionStatus: PropTypes.string
        })
    ).isRequired,
    reset: PropTypes.func.isRequired
};

export default ModalNuevoSoporte;
